<dx-data-grid biz-grid
    [selection]='{ mode: "none" }'
    [dataSource]='monitorSchedules()'
    [bizSetColumnChooser]="false"
    [bizSetGroupPanel]="false"
    [bizSetAllowColumnReordering]="false"
    (onInitNewRow)="onInitNewRow($event)"
    (onRowInserted)="onRowInserted($event)"
    (onRowUpdated)="onRowUpdated($event)"
    (onRowRemoved)="onRowRemoved($event)"
    (onRowValidating)="onRowValidating($event)"
    [bizEditRowOnDoubleClick]="true">

    <dxo-editing mode="popup" [allowUpdating]="allowUpdating()" [allowAdding]="allowAdding()" [allowDeleting]="allowDeleting()">

        <dxo-popup title="Item configuration" [showTitle]="true"></dxo-popup>

        <dxo-form [showRequiredMark]="true" requiredMark="*">
            <dxi-item dataField="Name" [colSpan]="1"></dxi-item>
            <dxi-item dataField="Description" [colSpan]="1"></dxi-item>
            <dxi-item dataField="ScheduledItem" [colSpan]="2"></dxi-item>
        </dxo-form>
    </dxo-editing>

    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

    <dxi-column dataField="Name" dataType="string" sortOrder="asc">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="Description" dataType="string">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="ScheduledItem" caption="Schedule" dataType="string" [allowGrouping]="false" [customizeText]="displayExprSchedule" editCellTemplate="editSchedule">
        <ng-container *dxTemplate="let cellInfo of 'editSchedule'">
            <label class="control control-checkbox">
                <input type="checkbox" [(ngModel)]="cellInfo.data.ScheduledItem.Enabled"/>
                <i></i>
                Enabled
            </label>
            <ep-schedule-item [scheduleItem]="$safeNavigationMigration(cellInfo?.data.ScheduledItem)" [hideTriggerEnd]="false" [readonly]="false" [showDates]="true" [requireWeekdaySelection]="true"
                (scheduleItemChange)="onScheduleItemChange($event, cellInfo)">
            </ep-schedule-item>
        </ng-container>
    </dxi-column>

    <dxi-column type="buttons">
        <dxi-button name="edit"></dxi-button>
        <dxi-button name="delete"></dxi-button>
        <dxi-button text="Show Log" template="logTemplate" [visible]="allowShowLog()"></dxi-button>
        <ng-container *dxTemplate="let cell of 'logTemplate'">
            <app-change-log-link [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
                <app-change-log-link-entity type="MonitorSchedule" [id]="cell.data.Id"></app-change-log-link-entity>
                <app-change-log-link-entity type="ScheduledItem" [id]="cell.data.ScheduledItem.Id"></app-change-log-link-entity>
            </app-change-log-link>
        </ng-container>
    </dxi-column>
</dx-data-grid>
